if (!customElements.get('wc-journal')) {
  customElements.define('wc-journal', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized || this.dataset.hub !== 'true') return;
      this.initialized = true;
      const grid = this.querySelector('[data-grid]');
      const tabs = Array.from(this.querySelectorAll('[data-filter]'));
      const more = this.querySelector('[data-load-more]');
      const empty = this.querySelector('[data-empty]');
      const archive = this.querySelector('[data-archive]');
      const status = this.querySelector('[data-status]');
      const pageSize = Number(this.dataset.pageSize) || 8;
      const cards = Array.from(grid.children).sort((a, b) => Number(b.dataset.date) - Number(a.dataset.date));
      let selected = 'all';
      let limit = pageSize;
      cards.forEach(card => grid.appendChild(card));
      cards.slice(0, 2).forEach(card => {
        const img = card.querySelector('img');
        if (img) img.loading = 'eager';
      });
      const update = () => {
        const matching = cards.filter(card => selected === 'all' || card.dataset.category === selected);
        cards.forEach(card => { card.hidden = true; });
        matching.slice(0, limit).forEach(card => { card.hidden = false; });
        more.hidden = matching.length <= limit;
        empty.hidden = matching.length !== 0;
        archive.hidden = selected === 'all';
        tabs.forEach(tab => {
          const active = tab.dataset.filter === selected;
          tab.classList.toggle('is-active', active);
          if (active) tab.setAttribute('aria-current', 'true');
          else tab.removeAttribute('aria-current');
        });
        const activeTab = tabs.find(tab => tab.dataset.filter === selected);
        if (selected !== 'all' && activeTab) archive.href = activeTab.href;
        status.textContent = `${Math.min(matching.length, limit)} / ${matching.length} ${status.dataset.label}`;
        return matching;
      };
      tabs.forEach(tab => tab.addEventListener('click', event => {
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
        event.preventDefault();
        selected = tab.dataset.filter;
        limit = pageSize;
        const before = grid.getBoundingClientRect().height;
        update();
        if (!matchMedia('(prefers-reduced-motion: reduce)').matches) {
          grid.animate([{ opacity: .35, transform: 'translateY(7px)' }, { opacity: 1, transform: 'translateY(0)' }], { duration: 280, easing: 'ease-out' });
        }
        if (before > 0) tab.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'auto' });
      }));
      more.addEventListener('click', () => {
        const prior = limit;
        limit += pageSize;
        const matching = update();
        const next = matching[prior]?.querySelector('.wcj-card__title a');
        if (next) next.focus({ preventScroll: true });
      });
      update();
    }
  });
}
